import { render, staticRenderFns } from "./SaleDocumentGeneration.vue?vue&type=template&id=a6faf004&scoped=true&"
import script from "./SaleDocumentGeneration.vue?vue&type=script&lang=ts&"
export * from "./SaleDocumentGeneration.vue?vue&type=script&lang=ts&"
import style0 from "./SaleDocumentGeneration.vue?vue&type=style&index=0&id=a6faf004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6faf004",
  null
  
)

export default component.exports